import { authenticatedPost } from '../../../api/request';

export default function updateWorkingMax(userId, exerciseId, value) {
    const url = `/v5/userWorkingMaxes`;
    const payload = {
        user_id: userId,
        working_maxes: [{ exercise_id: exerciseId, value: parseFloat(value) }]
    };
    return authenticatedPost(url, payload);
}



// WEBPACK FOOTER //
// ./src/v5/LastPerformance/api/updateWorkingMax.js